import { atom } from "jotai";
import {
  OrganizationMenuItem,
  OrganizationProfileInfo,
  WizardWashType,
} from "../types";
import { organizationMenuDefault } from "../components/organization";
export const isCreateOrganizationModeAtom = atom(false);
export const isOrganizationProfileBodyEditModeAtom = atom(false);
export const expandedOrganizationAccordionItemAtom =
  atom<OrganizationMenuItem | null>(organizationMenuDefault);
export const createOrganizationWizardStepAtom = atom(0);
export const organizationWizardWashTypesAtom = atom<WizardWashType[]>([]);
export const organizationWizardProfileAtom = atom<
  OrganizationProfileInfo | undefined
>(undefined);
export const isCreateOrganizationSuccessAtom = atom(false);
